<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>单位基础信息</Alert>

          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
            <FormItem
              label="单位名称"
              prop="Cname"
            >
              <Input
                v-model="formValidate.Cname"
                :maxlength="45"
                placeholder="请输入单位名称"
                disabled v-if="formValidate.Id !=0"
              ></Input>
              <Input
                v-model="formValidate.Cname"
                :maxlength="45"
                placeholder="请输入单位名称"
                v-if="formValidate.Id == 0"
              ></Input>
            </FormItem>
            <FormItem label="单位地址" prop="Caddress">
              <Input
                v-model="formValidate.Caddress"
                :maxlength="100"
                placeholder="请输入单位地址"
              ></Input>
            </FormItem>
            <FormItem label="单位简介" prop="Cintroduce">
              <Input
                type="textarea"
                v-model="formValidate.Cintroduce"
                placeholder="请输入"
              ></Input>
            </FormItem>
            <FormItem label="法人代表" prop="Crepresentative">
              <Input
                v-model="formValidate.Crepresentative"
                placeholder="请输入"
              ></Input>
            </FormItem>
            <FormItem label="联系人" prop="Ccontacts">
              <Input
                v-model="formValidate.Ccontacts"
                placeholder="请输入"
              ></Input>
            </FormItem>
            <FormItem label="联系电话" prop="Cphone">
              <Input
                v-model="formValidate.Cphone"
                placeholder="请输入"
              ></Input>
            </FormItem>
            <FormItem label="统一社会信用代码" prop="Ccode">
              <Input
                v-model="formValidate.Ccode"
                placeholder="请输入"
              ></Input>
            </FormItem>
<!--            <Modal title="查看图片" v-model="visible">-->
<!--              <img :src="imgName" style="width: 100%">-->
<!--            </Modal>-->
<!--            <Row :gutter="24">-->
<!--              <i-col span="24">-->
<!--            <Form-item label="营业执照" >-->
<!--              <div class="demo-upload-list" v-if="formValidate.Clicense">-->
<!--                <template >-->
<!--                  <img :src="formValidate.Clicense">-->
<!--                  <div class="demo-upload-list-cover">-->
<!--                    <Icon type="ios-eye-outline" @click="handleView(formValidate)" size="40"></Icon>-->
<!--                    <Icon type="ios-trash-outline" @click="handleRemove(formValidate)" size="40"></Icon>-->
<!--                  </div>-->
<!--                </template>-->

<!--              </div>-->
<!--              <Upload-->
<!--                :data="{pid:formValidate.Cuid}"-->
<!--                :show-upload-list="false"-->
<!--                :on-success="handleSuccess"-->
<!--                :format="['jpg','jpeg','png','pdf']"-->
<!--                :max-size="5120"-->
<!--                :on-format-error="handleFormatError"-->
<!--                :on-exceeded-size="handleMaxSize"-->
<!--                :before-upload="handleBeforeUpload"-->
<!--                name="up_img"-->
<!--                type="drag"-->
<!--                action="/v1/account/upload/file/"-->
<!--                style="display: inline-block;width:100px;">-->
<!--                <div style="width: 100px;height:100px;line-height: 100px;">-->
<!--                  <Icon type="ios-camera" size="40"></Icon>-->
<!--                </div>-->
<!--              </Upload>-->

<!--            </Form-item>-->
<!--              </i-col></Row>-->
            <FormItem label="规模" prop="Cscale">
              <el-select
                v-model="formValidate.Cscale"
                filterable
                default-first-option
                placeholder="请选择规模">
                <el-option
                  v-for="item in CscaleList"
                  :key="item.value"
                  :label="item.meaning"
                  :value="item.value">
                </el-option>
              </el-select>
            </FormItem>
            <FormItem label="行业" prop="Cindustry">
              <el-select
                v-model="formValidate.Cindustry"
                filterable

                default-first-option
                placeholder="请选择行业">
                <el-option
                  v-for="item in CindustryList"
                  :key="item.value"
                  :label="item.meaning"
                  :value="item.value">
                </el-option>
              </el-select>
            </FormItem>
            <FormItem label="类型" prop="Ctype">
              <el-select
                v-model="formValidate.Ctype"
                filterable

                default-first-option
                placeholder="请选择">
                <el-option
                  v-for="item in CtypeList"
                  :key="item.value"
                  :label="item.meaning"
                  :value="item.value">
                </el-option>
              </el-select>
            </FormItem>

            <FormItem>
              <Button
                type="primary"
                @click="handleSubmit('formValidate')"
              >更新
              </Button>


            </FormItem>


          </Form>
          <Spin size="large" fix v-if="spinShow"></Spin>


        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>


  import {
    getcompanyinfo,
    operationcompanyinfo
  } from '@/api/company/company.js'

  import {getsysparameterList} from "@/api/system/sys_parameter";

  // import {Notification} from 'element-ui';


  export default {

    data() {
      return {
        spinShow:false,
        fullscreenLoading:false,
        CtypeList:[],
        CindustryList:[],
        CscaleList:[],
        formValidate: {
          Id:0,
          Cname:'',
          Sbid:'',
          Caddress:'',
          Cintroduce:'',
          Crepresentative:'',
          Ccontacts:'',
          Cphone:'',
          Ccode:'',
          Clicense:'',
          Cindustry:'',
          Ctype:'',
          Cstate:0,
          Cuid:0,
          Cscale:''
        },
        imgName: '',
        visible: false,


        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Cname: [
            {
              required: true,
              message: "单位名字不能为空",
              trigger: "blur"
            }
          ],
          Caddress: [
            {
              required: true,
              message: "地址不能为空",
              trigger: "blur"
            }
          ],
          Cintroduce: [
            {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          ],
          Crepresentative: [
            {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          ],
          Ccontacts: [
            {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          ],
          Cphone: [
            {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          ],
          Ccode: [
            {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          ],
          Cscale: [
            {
              required: true,
              message: "请选择规模",
              trigger: "change"
            }
          ],
          Cindustry: [
            {
              required: true,
              message: "请选择行业",
              trigger: "change"
            }
          ],
          Ctype: [
            {
              required: true,
              message: "请选择类别",
              trigger: "change"
            }
          ],
        },

      };
    },
    beforeRouteLeave(to, from, next){
      if (!this.formValidate.Latitude||!this.formValidate.Longitude||!this.formValidate.Caddress||!this.formValidate.Cintroduce||!this.formValidate.Ccontacts||!this.formValidate.Cphone||!this.formValidate.Ctype||!this.formValidate.Cindustry||this.formValidate.Cintroduce=='请填写简介'||!this.formValidate.Cscale){
        this.showcompanymsg();
      }
      else{
        next(true);
      }

    },
    methods: {
      showcompanymsg(){
        this.$confirm('无法进行其他操作，请先完善单位信息?', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '完善资料',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {

        }).catch(action => {
          if (action === 'cancel') {
          }
        });
      },
      getcompanyinfo() {
        this.spinShow = true
        getcompanyinfo().then(res => {
          if (res.data.code === 0) {
            this.formValidate = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
            this.formValidate.Cuid = res.data.data
          }
          this.spinShow = false
        })
      },
      handleBeforeUpload(){
        this.spinShow = true
      },
      handleView (name) {
        this.imgName = name.url;
        this.visible = true;
      },
      handleRemove (file) {
        this.spinShow = true
        delpic(file.ID).then(res => {
          if (res.data.code === 0) {
            this.formValidate.Clicense=''


          } else {

            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })

      },
      handleSuccess (res, file) {
        // 因为上传过程为实例，这里模拟添加 url

        if(res.code == 0)
        {
          // let imgSrc = require('@/static/'+res.filename);
          let imgSrc = '/upload-image/'+res.filename;
          file.url = imgSrc;
          file.name = res.filename;
          this.formValidate.Clicense = imgSrc

        }else {
          this.$Message.error(`${res.msg}`)
        }


      },
      handleFormatError (file) {
        this.spinShow = false
        this.$Notice.warning({
          title: '文件格式不正确',
          desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
        });
        this.spinShow = false
      },
      handleMaxSize (file) {
        this.spinShow = false
        this.$Notice.warning({
          title: '超出文件大小限制',
          desc: '文件 ' + file.name + ' 太大，不能超过 5M。'
        });
        this.spinShow = false
      },

      getCindustryList() {
        getsysparameterList('company_info', 'Cindustry').then(res => {
          if (res.data.code === 0) {
            this.CindustryList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getCscaleList() {
        getsysparameterList('company_info', 'Cscale').then(res => {
          if (res.data.code === 0) {
            this.CscaleList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getCtypeList() {
        getsysparameterList('company_info', 'Ctype').then(res => {
          if (res.data.code === 0) {
            this.CtypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },

      handleSubmit(value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            this.spinShow = true
            setTimeout(() => {
              operationcompanyinfo(this.formValidate, 'POST').then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getcompanyinfo()

                } else {
                  this.$Message.error(`${res.data.msg}`)
                  this.spinShow = false
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数');
            this.spinShow = false
          }
        })
      },

    },

    mounted() {
      this.getcompanyinfo()
      this.getCindustryList()
      this.getCtypeList()
      this.getCscaleList()

    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
  .demo-upload-list{
    display: inline-block;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
